<header class="container-header">
    <mat-toolbar>
        <div class="header">
            <div class="content-logo">
                <div class="logo" aria-label="Logotipo principal"></div>
            </div>
            <div class="content-user">

                <div class="notifications" appClickedOutside (clickedOutside)="onHandle()">
                    <div class="laureate-icon" aria-label="Notificaciones" (click)=" closePanel(isDialogOpen) " (keydown.enter)=" closePanel(isDialogOpen) ">
                        <img src="assets/img/icons/icon_notification.svg" alt="" aria-hidden="true">
                    </div>
                    <div class="pulser" *ngIf="thereAreNewNotifications" aria-live="polite">
                        <span>{{countNotifications}}</span>
                    </div>
                    <div class="modal-container" *ngIf="isDialogOpen">
                        <app-modal-notifications (closePanel)=" closePanel(true) "> </app-modal-notifications>
                    </div>
                </div>

                <div class="dropdown-menu">
                    <button class="btn-user" mat-button>
                        <span class="letters-user bg-button">{{dataUser.lettersName}}</span>
                        {{dataUser.fullName}}
                        <mat-icon class="icon-arrow">keyboard_arrow_down</mat-icon>
                    </button>

                    <div class="menu-panel mat-elevation-z4">
                        <button mat-button (click)="goPerfil()">
                            <img class="icon-profile" src="./assets/img/icons/icon_profile.svg" alt="" aria-hidden="true" />
                            {{ "login.perfil-btn" | translate}}
                        </button>
                        <button mat-button (click)="logout()">
                            <img class="icon-logout" src="./assets/img/icons/icon_logout.svg" alt="" aria-hidden="true" />
                            {{ "login.logout-btn" | translate}}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </mat-toolbar>
</header>
